var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_132464",
    "data-name": "Group 132464",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.609,
    height: 40,
    viewBox: "0 0 35.609 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_168",
    "data-name": "Line 168",
    d: "M22.545,1.249H.189a.971.971,0,0,1-.939-1,.971.971,0,0,1,.939-1H22.545a.971.971,0,0,1,.939,1A.971.971,0,0,1,22.545,1.249Z",
    transform: "translate(6.209 24.844)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_169",
    "data-name": "Line 169",
    d: "M22.545,1.249H.189a.971.971,0,0,1-.939-1,.971.971,0,0,1,.939-1H22.545a.971.971,0,0,1,.939,1A.971.971,0,0,1,22.545,1.249Z",
    transform: "translate(6.209 31.118)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6007",
    "data-name": "Rectangle 6007",
    d: "M2.945-.75H31.164a3.7,3.7,0,0,1,3.7,3.7V35.555a3.7,3.7,0,0,1-3.7,3.7H2.945a3.7,3.7,0,0,1-3.7-3.7V2.945A3.7,3.7,0,0,1,2.945-.75ZM31.164,37.335a1.782,1.782,0,0,0,1.78-1.78V2.945a1.782,1.782,0,0,0-1.78-1.78H2.945a1.782,1.782,0,0,0-1.78,1.78V35.555a1.782,1.782,0,0,0,1.78,1.78Z",
    transform: "translate(0.75 0.75)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_170",
    "data-name": "Line 170",
    d: "M10.578,1.249H.249a1,1,0,0,1,0-2H10.578a1,1,0,1,1,0,2Z",
    transform: "translate(6.209 18.571)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91133",
    "data-name": "Path 91133",
    d: "M175.936,16.192l-5.123-5.123a1,1,0,1,1,1.413-1.413l3.71,3.71,7.933-7.933a1,1,0,0,1,1.413,1.413Z",
    transform: "translate(-154.488 0.708)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLI1);
export default __webpack_public_path__ + "static/media/l-i-1.6df489c699f7c8fb0cd2351268aeccf2.svg";
export { ForwardRef as ReactComponent };